var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSharedusepath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 384 512",
    style: {
      enableBackground: "new 0 0 384 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#68995D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 187.4,
    cy: 175,
    rx: 146.7,
    ry: 140.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M207.5,102.6c11.1,0,20.1-9,20.1-20.1s-9-20.1-20.1-20.1c-11.1,0-20.1,9-20.1,20.1S196.4,102.6,207.5,102.6z  M247,164.9l-9.7-4.9l-4.1-12.3c-6.1-18.6-23.3-31.7-42.7-31.7c-15.1,0-23.4,4.2-39,10.5c-9,3.6-16.4,10.5-20.8,19.3l-2.8,5.7 c-3.3,6.6-0.6,14.6,5.9,17.9c6.5,3.3,14.5,0.6,17.8-6l2.8-5.7c1.5-2.9,3.9-5.2,6.9-6.4l11.2-4.5l-6.4,25.4 c-2.2,8.7,0.2,17.9,6.2,24.6l25,27.3c3,3.3,5.1,7.3,6.2,11.6l7.7,30.6c1.8,7.1,9.1,11.5,16.2,9.7c7.1-1.8,11.5-9.1,9.7-16.2 l-9.3-37.2c-1.1-4.3-3.2-8.3-6.2-11.6l-19-20.8l7.2-28.7l2.3,6.9c2.2,6.7,7,12.3,13.3,15.5l9.7,4.9c6.5,3.3,14.5,0.6,17.8-6 C256.2,176.3,253.5,168.2,247,164.9L247,164.9z M151.3,223.7c-1.3,3.4-3.3,6.4-5.9,9l-20.9,20.9c-5.2,5.2-5.2,13.7,0,18.9 c5.2,5.2,13.7,5.2,18.9,0l24.8-24.8c2.6-2.6,4.6-5.6,5.9-9l5.6-14.1c-23.1-25.2-16.2-17.5-19.8-22.5 C159.9,202.2,151.3,223.7,151.3,223.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M192,512c0,0,192-208,192-320C384,86,298,0,192,0S0,86,0,192C0,304,192,512,192,512z M190.1,45.6 c71.5,0,129.4,57.9,129.4,129.4s-57.9,129.4-129.4,129.4S60.7,246.4,60.7,175S118.6,45.6,190.1,45.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharedusepath);
export default __webpack_public_path__ + "static/media/sharedusepath.543d703e449cf1167af99a3ad52fb772.svg";
export { ForwardRef as ReactComponent };